import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApplicationService } from '@app/applications/application.service';
import { LoanApplication, ApplicationAccessSpecifier, LoanProduct } from '@app/applications/applications.model';
import { ValidationService } from '../../../application-validators/validation.service'
import { MatSnackBar } from '@angular/material';
import { ControlValidators } from '@app/applications/application-validators/control-validators.directive';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
@Component({
  selector: 'eng-loan-assessment',
  templateUrl: 'loan-recommendation.template.html',
  styleUrls: ['../../application-details.styles.scss', './loan-recommendation.scss']
})
export class LoanAssessmentComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
  menuCode: string;

  loanRecommendationCompositeDto: any = {};
  loanRecommendationForm: FormGroup;

  isFormDisabled: boolean;
  allowAccess: boolean;
  menuItemAllowAccess: boolean;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  matchingProduct: LoanProduct;
  loanProducts: LoanProduct[];
  minLoanAmount: number;
  maxLoanAmount: number;
  requestedloanProducts: LoanProduct[];

  constructor(private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private validationService: ValidationService,
    private referenceCodeService: ReferenceCodeService,) {
    this.loanRecommendationForm = this.formBuilder.group({
      proposedAmount: [''],
      tenure: [''],
      roi: [''],
    });
    this.allowAccess = this.applicationService.allowAccess;
  }

  ngOnInit() {
    this.isFormDisabled = true;
    this.getSalesLoanRecommendation();
    this.getMenuItemAccess();
    this.loanRecommendationForm.disable();
    this.getLoanProducts();
  }

  getSalesLoanRecommendation() {
    let roi = this.loanRecommendationForm.getRawValue().roi;
    let tenure = this.loanRecommendationForm.getRawValue().tenure;
    let loanAmount = this.loanRecommendationForm.getRawValue().proposedAmount;
    this.applicationService.getLoanRecommendation(this.application.uid, roi, tenure, loanAmount).subscribe((response: any) => {
      if (response.body && response.body.loanRecommendation) {
        this.loanRecommendationCompositeDto = response.body.loanRecommendation;
        this.buildLoanRecommendationForm(response.body.loanRecommendation);
      }
    });
  }

  buildLoanRecommendationForm(loanRecommendation?: any) {
    const loanRecommendationData = loanRecommendation.calculatedLoanRecommendationData || {};

    if (loanRecommendationData) {

      const data = loanRecommendation.calculatedLoanRecommendationData;

      this.loanRecommendationForm.patchValue({
        proposedAmount: data.proposedAmount,
        tenure: data.tenure,
        roi: data.roi,
      });
    }
  }

  saveLoanRecommendationDetails() {
    this.validationService.markFormGroupTouched(this.loanRecommendationForm);

    if (!this.isFormDisabled && this.loanRecommendationForm.valid) {

      const formValue = this.loanRecommendationForm.getRawValue();

      if (!this.loanRecommendationCompositeDto) {
        this.loanRecommendationCompositeDto = {};
      }

      const existingData =
        this.loanRecommendationCompositeDto.calculatedLoanRecommendationData || {};

      this.loanRecommendationCompositeDto.calculatedLoanRecommendationData = {
        ...existingData, 
        proposedAmount: formValue.proposedAmount,
        tenure: formValue.tenure,
        roi: formValue.roi
      };

      const payload = {
        loanRecommendation: this.loanRecommendationCompositeDto
      };

      this.applicationService.saveLoanRecommendation(this.application.uid, payload).toPromise().then(
        (_success) => {
          this._snackbar.open("Loan recommendation updated successfully", "Close", {
            duration: 2000,
          });
          this.loanRecommendationCompositeDto.persistedLoanRecommendationData = _success.body.loanRecommendation.calculatedLoanRecommendationData;
          this.isFormDisabled = true;
          this.loanRecommendationForm.disable();
        }, (failure) => {
          let errormesg = []
          errormesg.push(failure)
          this.applicationService.displayErrorMessages(errormesg);
        }
      );
    }
  }

  getLoanProducts() {
    this.referenceCodeService.getLoanProducts(this.application.productTypeProp)
      .subscribe((response: any) => {
        this.loanProducts = response.body;
        this.loanProducts.forEach(loanProduct => {
          if (!this.minLoanAmount || loanProduct.minAmount < this.minLoanAmount) {
            this.minLoanAmount = loanProduct.minAmount;
          }
          if (!this.maxLoanAmount || loanProduct.maxAmount > this.maxLoanAmount) {
            this.maxLoanAmount = loanProduct.maxAmount;
          }
        });
        this.setMatchingProduct();
      });
    this.referenceCodeService.getLoanProducts(this.application.productTypeReq)
      .subscribe((response: any) => {
        this.requestedloanProducts = response.body;
        if (this.application.productTypeProp == null) {
          this.loanProducts = this.requestedloanProducts
          this.requestedloanProducts.forEach(loanProduct => {
            if (!this.minLoanAmount || loanProduct.minAmount < this.minLoanAmount) {
              this.minLoanAmount = loanProduct.minAmount;
            }
            if (!this.maxLoanAmount || loanProduct.maxAmount > this.maxLoanAmount) {
              this.maxLoanAmount = loanProduct.maxAmount;
            }
          });
          this.setMatchingProduct();
        }
      });
  }

  setMatchingProduct() {
    this.matchingProduct = this.loanProducts.find(loanProduct => loanProduct.productCode === (this.application.productCodeProp ? this.application.productCodeProp : this.application.productCodeReq));
    this.setMinMaxLoanAmount(this.matchingProduct)
  }

  setMinMaxLoanAmount(product) {
    this.minLoanAmount = product.minAmount;
    this.maxLoanAmount = product.maxAmount;

    this.loanRecommendationForm.controls['proposedAmount']
      .setValidators([ControlValidators.numericRangeValidator(this.minLoanAmount,
        this.maxLoanAmount, true, true, "Should be in the range.. " +
        this.minLoanAmount.toLocaleString('en-IN') + " to " +
      this.maxLoanAmount.toLocaleString('en-IN')), ControlValidators.patternValidator("[0-9]*", "Amount shoud be number,Decimal values are not allowed")]);
    this.loanRecommendationForm.controls['proposedAmount'].updateValueAndValidity()
    this.validationService.markFormGroupTouched(this.loanRecommendationForm)
  }

  validateTenureAndInterest() {
    let tenureControl = this.loanRecommendationForm.controls['tenure'];
    let interestControl = this.loanRecommendationForm.controls['roi'];

    if (this.matchingProduct != undefined) {
      tenureControl.setErrors({});
      tenureControl.setValidators([ControlValidators.numericRangeValidator(
        this.matchingProduct.minTenure, this.matchingProduct.maxTenure,
        true, true, "Tenure should be in the range.. " +
        this.matchingProduct.minTenure.toLocaleString('en-IN') + " to " +
      this.matchingProduct.maxTenure.toLocaleString('en-IN')), ControlValidators.patternValidator("[0-9]*", "Decimal values are not allowed")]);

      interestControl.setErrors({});
      interestControl.setValidators([ControlValidators.numericRangeValidator(
        this.matchingProduct.minInterest, this.matchingProduct.maxInterest,
        true, true, "Roi should be in the range.. " +
        this.matchingProduct.minInterest.toLocaleString('en-IN') + " to " +
      this.matchingProduct.maxInterest.toLocaleString('en-IN')), ControlValidators.maxLengthValidator(5, "Invalid")]);
    } else {
      // if product is not found then matching product will be undefined then we are clearing validators and setting error message for proposed amount field
      this.loanRecommendationForm.controls['proposedAmount']
        .setErrors({ customError: 'Product not found for this amount' });
    }

    tenureControl.updateValueAndValidity();
    interestControl.updateValueAndValidity();
  }

  enableDisableForm() {
    this.validateTenureAndInterest();
    this.loanRecommendationForm.enable();
    this.loanRecommendationForm.controls.roi.disable();
    this.isFormDisabled = false;
  }

  cancelForm() {
    this.isFormDisabled = true;
    this.buildLoanRecommendationForm(this.loanRecommendationCompositeDto);
    this.loanRecommendationForm.disable();
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }
}